module.exports = __webpack_public_path__ + "media/images/icon-line-white-df00555302456a97c9ba147db5eb1fb6.svg";